import Flickity from 'flickity';
import 'flickity-fade';

const initCarousels = (elements) => {
    elements.forEach((element) => {
        let contain = true;
        let dots = false;
        let prevNext = false;
        let watchCss = false;
        let align = 'left';
        let draggable = false;
        let wrap = false;
        let fullScreen = false;
        let setGallerySize = true;
        let fade = false;
        let autoplay = false;
        let adaptive = false;

        if (element.dataset.noContain) {
            contain = false;
        }

        if (element.dataset.draggable) {
            draggable = true;
        }

        if (element.dataset.carouselDots) {
            dots = true;
        }

        if (element.dataset.carouselAlign) {
            align = element.dataset.carouselAlign;
        }

        if (element.dataset.carouselNav) {
            prevNext = true;
        }

        if (element.dataset.watchCss) {
            watchCss = true;
        }

        if (element.dataset.wrap) {
            wrap = true;
        }

        if (element.dataset.fullScreen) {
            fullScreen = true;
        }

        if (element.dataset.customSize) {
            setGallerySize = false;
        }

        if (element.dataset.fade) {
            fade = true;
        }

        if (element.dataset.autoplay) {
            autoplay = 6000;
        }

        if (element.dataset.adaptive) {
            adaptive = true;
        }

        const flickityOptions = {
            autoPlay: autoplay,
            cellAlign: align,
            wrapAround: wrap,
            contain,
            prevNextButtons: prevNext,
            arrowShape: 'M46.1563 91.5L56.8325 80.895L33.6725 57.735L95 57.735L95 42.765L33.6725 42.765L56.8325 19.605L46.1563 9L5 50.25L46.1563 91.5Z',
            pageDots: dots,
            draggable,
            setGallerySize,
            watchCSS: watchCss,
            fullscreen: fullScreen,
            fade,
            adaptiveHeight: adaptive
        };

        // Force slide height to match
        if (element.dataset.matchHeight) {
            flickityOptions.on = {};

            flickityOptions.on.ready = () => {
                const slides = element.querySelectorAll('.flickity-cell');

                slides.forEach((slide) => {
                    slide.style.height = '100%';
                });
            };
        }

        const carousel = new Flickity(element, flickityOptions); // eslint-disable-line;

        // Force resize for wrapped ones
        if (element.dataset.wrap || element.dataset.fade) {
            carousel.resize();
        }

        if (element.nextElementSibling || element.previousElementSibling) {
            // Nav el check
            let nav = null;

            if (element.nextElementSibling && element.nextElementSibling.dataset.carouselNav) {
                nav = element.nextElementSibling;
            }

            if (element.previousElementSibling && element.previousElementSibling.dataset.carouselNav) {
                nav = element.previousElementSibling;
            }

            if (nav) {
                const prev = nav.querySelector('.js-carousel-prev');
                const next = nav.querySelector('.js-carousel-next');

                if (prev) {
                    prev.addEventListener('click', () => {
                        carousel.previous(wrap);
                    });
                }

                if (next) {
                    next.addEventListener('click', () => {
                        carousel.next(wrap);
                    });
                }
            }
        }
    });
};

export { initCarousels as default };
